'use strict'

import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);

export default class Period extends React.Component {
  constructor(props) {
    super(props);
    var from=props.value!==undefined
      ? props.value.from!==undefined
        ? props.value.from
        : typeof props.value==="string"
          ? new Date(props.value.split(" to ")[0])
          : undefined
      : undefined;
    var to=props.value!==undefined
      ? props.value.to!==undefined
        ? props.value.to
        : typeof props.value==="string"
          ? new Date(props.value.split(" to ")[1])
          : undefined
      : undefined;
    this.state = {
      from: from!==undefined ? new Date(from) : null,
      to: to!==undefined ? new Date(to) : null,
      edit: !from || !to
    };
  }

  handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range);
    if (this.props.onChange!==undefined) {
      this.props.onChange({target: {name: this.props.name, value: range}});
    }
  }

  handleResetClick(e) {
    e.preventDefault();
    this.setState({edit:!this.state.edit});
  }

  render() {
    let labels=translations.getTranslation(this.props).period;
    const { from, to, edit  } = this.state;
    return (
      <div>
        <input type="hidden" name={this.props.name} value={(from && to ? new Date(from).toISOString().slice(0,10)+" to "+new Date(to).toISOString().slice(0,10) : "")}/>
        <div style={{paddingTop: edit ? 3 : 0}}>
          {!from && !to && <span>{labels.pleaseSelect} <strong>{labels.firstDay}</strong>.</span>}
          {from && !to && <span>{labels.pleaseSelect} <strong>{labels.lastDay}</strong>.</span>}
          {!from && to && <span>{labels.fromUndefinedTo} {new Date(to).toISOString().slice(0,10)}</span>}
          {from &&
            to &&
            <span>
              {labels.from}
              {' '}
              {new Date(from).toISOString().slice(0,10)}
              {' '}
              {labels.to}
              {' '}
              {new Date(to).toISOString().slice(0,10)}
              {' '}
            </span>}
            {!edit && <a style={{display:"inline-block", verticalAlign:"middle"}} href="." onClick={this.handleResetClick.bind(this)}><img src="/icons/pen_grey_tran.png"/></a> }
        </div>
        {edit &&
          <div>
            <DayPicker
              numberOfMonths={2}
              selectedDays={[from, { from, to }]}
              onDayClick={this.handleDayClick.bind(this)}
              fixedWeeks
              month={from!==null ? new Date(from) : undefined}
              months={labels.months}
              weekdaysShort={labels.weekdaysShort}
              firstDayOfWeek={1}
              showWeekNumbers
            />
            <div>
              <a href="." onClick={this.handleResetClick.bind(this)}>{labels.hideCalendar}</a>
            </div>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/Period.jsx